module.exports = __webpack_public_path__ + "img/features_3.79b8e169.png";